import React from "react";
import { FilterChipProps } from "./FilterChip.types";
import { ChipContainer, ChipIcon, IconWrapper } from "./FilterChip.styles";
import { Body6RegularTypography } from "../../primitives/Typography/typographyVariants";

export const FilterChip: React.FC<FilterChipProps> = ({
  label,
  isSelected = false,
  leftIcon,
  rightIcon,
  onClick,
  onLeftIconClick,
  onRightIconClick,
  dataCy,
}) => {
  const handleChipClick = () => {
    if (onClick) {
      onClick(); // Call external onClick function if provided
    }
  };
  const handleLeftIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onLeftIconClick) onLeftIconClick();
  };

  const handleRightIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onRightIconClick) onRightIconClick();
  };

  return (
    <ChipContainer
      data-cy={dataCy}
      isSelected={isSelected}
      onClick={handleChipClick}
    >
      {leftIcon && (
        <IconWrapper
          onClick={onLeftIconClick ? handleLeftIconClick : undefined}
        >
          <ChipIcon className={leftIcon} />
        </IconWrapper>
      )}
      <Body6RegularTypography>{label}</Body6RegularTypography>
      {rightIcon && (
        <IconWrapper
          onClick={onRightIconClick ? handleRightIconClick : undefined}
        >
          <ChipIcon className={rightIcon} />
        </IconWrapper>
      )}
    </ChipContainer>
  );
};

export default FilterChip;
